import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var VirtualTourSVG = function VirtualTourSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__secondary-color-fill",
    points: "22.008 36.057 22.011 36.066 22.014 36.057 22.008 36.057"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__secondary-color-fill",
    points: "22.008 2.075 22.006 2.066 22.003 2.075 22.008 2.075"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M31.167,13h6.7A16.993,16.993,0,0,0,25.085,2.367C27.221,3.936,30,7.056,31.167,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M12.3,19.066a34.329,34.329,0,0,1,.19-3.641H5.418a16.73,16.73,0,0,0,0,7.282h7.071A34.329,34.329,0,0,1,12.3,19.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M12.85,25.134h-6.7A16.993,16.993,0,0,0,18.931,35.765C16.8,34.2,14.013,31.076,12.85,25.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M18.931,2.367A16.993,16.993,0,0,0,6.153,13h6.7C14.013,7.056,16.8,3.936,18.931,2.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M22.009,34.764c1.176-.486,5.143-2.63,6.671-9.63H15.337C16.863,32.125,20.823,34.273,22.009,34.764Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M25.085,35.765A16.993,16.993,0,0,0,37.864,25.134h-6.7C30,31.076,27.221,34.2,25.085,35.765Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M22.008,3.368C20.82,3.861,16.862,6.01,15.337,13H28.68C27.154,6.01,23.2,3.861,22.008,3.368Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M14.726,19.066a31.126,31.126,0,0,0,.22,3.641H29.071a31.137,31.137,0,0,0,.219-3.641,31.137,31.137,0,0,0-.219-3.641H14.946A31.126,31.126,0,0,0,14.726,19.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M31.718,19.066a34.329,34.329,0,0,1-.19,3.641H38.6a16.771,16.771,0,0,0,0-7.282H31.528A34.329,34.329,0,0,1,31.718,19.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M19.33,38.51l.064.005c.43.024.863.044,1.3.056h.039a1.267,1.267,0,0,0,.035-2.533c-.414-.013-.825-.03-1.229-.053-.137-.008-.265-.022-.4-.032l1.19,1.376Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M35.933,23.158v2.881c1.609.942,2.534,2,2.534,3.022,0,2.083-4.049,4.79-11.554,5.7a1.267,1.267,0,0,0,.307,2.515C35.591,36.26,41,33.034,41,29.061,41,26.723,39.1,24.668,35.933,23.158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M19.157,31.1a1.266,1.266,0,1,0-1.914,1.659l1.9,2.192c-8.413-.574-13.608-3.477-13.608-5.893,0-1.019.925-2.08,2.534-3.022V23.158C4.9,24.668,3,26.723,3,29.061c0,4.4,6.711,7.871,16.33,8.449l-2.1,2.47a1.267,1.267,0,0,0,1.932,1.639l3.8-4.479a1.265,1.265,0,0,0-.008-1.648Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M32.957,16.728,26.623,11.37a1.272,1.272,0,0,0-.823-.3H18.2a1.272,1.272,0,0,0-.823.3l-6.334,5.358a1.283,1.283,0,0,0-.443.963v7.942a1.9,1.9,0,0,0,1.9,1.9h19a1.9,1.9,0,0,0,1.9-1.9V17.691A1.283,1.283,0,0,0,32.957,16.728ZM23.267,25h-3.8V22.466a1.267,1.267,0,0,0-2.534,0V25h-3.8V18.273L18.2,13.992l5.067,4.281Zm7.6,0H25.8V17.691a1.283,1.283,0,0,0-.443-.963L22,13.891l-.342-.292h3.673l5.536,4.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M19.467,25V22.466a1.267,1.267,0,0,0-2.534,0V25Z"
  }));
};
VirtualTourSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
VirtualTourSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Virtual Tour")
};
export default withDetailedIcon(VirtualTourSVG);